import { useTranslation } from 'react-i18next';

import {
  ProjectInfo,
  ProjectMedias,
  ProjectsContainer,
  WorksSectionContainer,
} from './styles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CustomSlider from '../ProjectsSlider';

import { projectImages, projectTechs } from './projectData';

export default function WorksSection() {
  const { t } = useTranslation();

  const projects = [
    {
      id: 1,
      title: 'Skolen',
      textKey: 'work_1_text',
      images: projectImages.skolen,
      techs: projectTechs.skolen,
    },
    {
      id: 2,
      title: 'GT Group',
      textKey: 'work_2_text',
      images: projectImages.gtGroup,
      techs: projectTechs.gtGroup,
    },
    {
      id: 3,
      title: 'Casa do Tenista',
      textKey: 'work_3_text',
      images: projectImages.casa,
      techs: projectTechs.casa,
    },
    {
      id: 4,
      title: 'Covabra',
      textKey: 'work_4_text',
      images: projectImages.covabra,
      techs: projectTechs.covabra,
    },
    {
      id: 5,
      title: 'Netflix Clone React',
      textKey: 'work_5_text',
      images: projectImages.netflix,
      techs: projectTechs.netflix,
      repoLink: 'https://github.com/cristofergadens/NetflixReact',
    },
  ];

  return (
    <WorksSectionContainer id="works">
      <h2 className="title">{t('works_general_title')}</h2>
      <p className="text">{t('works_intro_text')}</p>

      {projects.map((project, index) => (
        <ProjectsContainer key={project.id}>
          {index % 2 === 0 ? (
            <>
              <ProjectInfo>
                {project.title === 'Netflix Clone React' ? (
                  <a
                    href="https://react-netflixx.vercel.app/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <h3 className="title">{project.title}</h3>
                  </a>
                ) : (
                  <h3 className="title">{project.title}</h3>
                )}

                <p className="text">{t(project.textKey)}</p>
                {project.repoLink && (
                  <a
                    href={project.repoLink}
                    target="_blank"
                    rel="noreferrer"
                    className="code-link"
                  >
                    Código do Repositório
                  </a>
                )}
                <p className="text2">tecnologias usadas:</p>
                <div className="techs">
                  {project.techs.map((tech) => (
                    <img key={tech.id} src={tech.src} alt={tech.alt} />
                  ))}
                </div>
              </ProjectInfo>
              <ProjectMedias>
                <CustomSlider images={project.images} />
              </ProjectMedias>
            </>
          ) : (
            <>
              <ProjectMedias>
                <CustomSlider images={project.images} />
              </ProjectMedias>
              <ProjectInfo>
                <h3 className="title">{project.title}</h3>
                <p className="text">{t(project.textKey)}</p>
                {project.repoLink && (
                  <a
                    href={project.repoLink}
                    target="_blank"
                    rel="noreferrer"
                    className="code-link"
                  >
                    Código do Repositório
                  </a>
                )}
                <p className="text2">tecnologias usadas:</p>
                <div className="techs">
                  {project.techs.map((tech) => (
                    <img key={tech.id} src={tech.src} alt={tech.alt} />
                  ))}
                </div>
              </ProjectInfo>
            </>
          )}
        </ProjectsContainer>
      ))}
    </WorksSectionContainer>
  );
}
